<template>
  <div>
    <d-header
      fluid
      :breadcrumbs="false"
      :actions="[{
        label: $t('save'),
        primary: true,
        color: 'is-primary',
        action: submitForm
      }]"
    >
      <h1 class="title">
        <d-previous-btn
          :path="'/properties/' + $route.params.property + '/application-files'"
        />
        {{ $t('new_application_file') }}
      </h1>
    </d-header>

    <v-form
      v-if="property"
      ref="form"
      action="create"
      :property="property"
    />
  </div>
</template>

<script>
import form from "./_form.vue";
export default {
  metaInfo() {
    return {
      title: this.$t("new_application_file")
    };
  },
  components: {
    "v-form": form
  },
  data() {
    return {
      property: null,
    };
  },
  created() {
    this.getProperty();
  },
  methods: {
    submitForm () {
      this.$refs.form.$refs.form.submit();
    },
    getProperty() {
      this.$http
        .get(
          this.$laravel.route("api.properties.show", {
            property: this.$route.params.property
          })
        )
        .then(response => {
          this.property = response.data.data;
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
};
</script>
